import styled from 'styled-components';
import { Skeleton } from '../Skeleton.styles';

export const GridSkeleton = styled(Skeleton)`
  height: 27.6rem;
  border-radius: 12px;
  overflow: hidden;

  @media (min-width: 761px) {
    height: 24rem;
  }
`;

export const ListSkeleton = styled.div`
  overflow: hidden;
  position: relative;
  border-radius: 12px;
  border: 1px solid #2d2d32;
  background: #18181a;
`;

export const ListSkeletonMedia = styled(Skeleton)`
  width: 100%;
  aspect-ratio: 1 / 1;
  border: none;
`;

export const ListSkeletonContent = styled.div`
  padding: 1.2rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

export const ListSkeletonLine = styled(Skeleton)`
  height: ${({ $height = '1.6rem' }) => $height};
  width: ${({ $width = '100%' }) => $width};
  border-radius: 999px;
  border: none;
`;

export const ListSkeletonRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
`;
